export type ChatMessageType = 'asked' | 'answer'

export const RECOMMENDATIONS_ONBOARDING_WAS_SEEN_KEY = 'recommendationsOnboardingWasSeen'
